export interface UseTODOOptions {
  hideInProduction?: boolean;
  hideInPreProduction?: boolean;
  hideInRelease?: boolean;
}

export const useTODO = ({
  hideInProduction = true,
  hideInPreProduction = true,
  hideInRelease = false
}: UseTODOOptions = {}): boolean => {
  return (
    (hideInProduction && import.meta.env.MODE == 'production') ||
    (hideInPreProduction && import.meta.env.MODE == 'preprod') ||
    (hideInRelease && import.meta.env.PROD)
  );
};
